import { useEffect, useRef } from "react";

export function useImmediateFetch(fetch?: Function) {
  const mounted = useRef(false);
  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true;
      fetch?.();
    }
  }, [fetch]);
}
